import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DsBoxModule,
  DsRowData,
  DsIconModule,
  DsButtonModule,
  DsLinkModule,
  DsSkeletonModule,
  DsFormsModule,
} from '@bmw-ds/components';
import { ICDQuartzTheme } from '../../shared/ag-theme';
import {
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
} from '@bmw-ds/components';
import { ApiService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { CampaignInventoryInternalSearch } from '../campaign_inventory_internal_search/campaign-inventory-internal-search/campaign-inventory-internal-search';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import {
  GridApi,
  GridReadyEvent,
  ColDef,
  GridOptions,
  ModuleRegistry,
  AllCommunityModule,
  Theme,
} from 'ag-grid-community';
import { ViewDataRendererComponent } from '../../shared/view-data-renderer/view-data-renderer';
import { CommonService } from 'src/app/services/common.service';
import { ExportService } from 'src/app/services/export.service';
ModuleRegistry.registerModules([AllCommunityModule]);
@Component({
  selector: 'app-campaign-inventory-internal-market',
  imports: [
    CommonModule,
    DsBoxModule,
    DsIconModule,
    CampaignInventoryInternalSearch,
    AgGridModule,
    AgGridAngular,
    DsButtonModule,
    DsLinkModule,
    DsSkeletonModule,
    DsFormsModule,
  ],
  standalone: true,
  templateUrl: './campaign-inventory-internal-market.html',
  styleUrls: ['./campaign-inventory-internal-market.scss'],
})
export class CampaignInventoryInternalMarket implements OnInit {
  theme: Theme | 'legacy' = ICDQuartzTheme;
  noRowsTemplate =
    '<div class="icd-no-rows" role="status" aria-live="polite">No Rows Found</div>';
  paginationPageSize: number = 10;
  paginationPageSizeSelector: number[] | boolean = [10, 20, 30];
  rowData: DsRowData[] = [];
  private gridApi!: GridApi;
  dynamicTableHeight: number = 540;
  private readonly ROW_HEIGHT = 40;
  private readonly HEADER_HEIGHT = 50;
  private readonly FLOATING_FILTER_HEIGHT = 30;
  private readonly PAGINATION_PANEL_HEIGHT = 48;
  private readonly MAX_VISIBLE_ROWS = 20;
  selectedValue: any;
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: 'Details are being displayed, this may take few seconds..',
    loadingText:
      'Please do not close the browser window. wait while we load data.',
  };
  regionScreenSelectedValue: any;
  marketTableData: any;
  userEnteredDefectCode: any;
  isMarketFilterActive: boolean = false;
  marketFilterValue: any;
  constructor(
    private route: Router,
    private apiService: ApiService,
    private router: Router,
    private loadingAreaService: DsLoadingAreaService,
    private commonService: CommonService,
    private exportService: ExportService
  ) {}

  ngOnInit() {
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.router.routerState.root.queryParams.subscribe((params: any) => {
      // console.log('Query Params of market:', params);
      this.regionScreenSelectedValue = params?.['value'] || this.commonService.regionalScreenSelectedValue.getValue() || '';

      // console.log('Selected Value from query params or service:', this.regionScreenSelectedValue);
    });
    //  console.log('spliting the market and market code:', this.regionScreenSelectedValue.split("-")[0] || "", this.regionScreenSelectedValue.split("-")[1] || "");
    this.commonService.defectCode.subscribe((value) => {
      this.userEnteredDefectCode = value;
      // this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
      const payload = {
        "defectCode": this.userEnteredDefectCode || null,
        "region": "",
        "market": this.regionScreenSelectedValue.split("-")[0] || "",
        "marketCode": this.regionScreenSelectedValue.split("-")[1] || "",
        "nationalScreen": false,
        "regionScreen": false,
        "marketScreen": true,
      };
      this.rowData = [];
      this.commonService.defectCodeTableData.subscribe((data) => {
        this.marketTableData = data;
        this.rowData = this.marketTableData.map((row: any) => {
          return {
            Market: row['centerCodeAndName'] ?? null,
            VehiclesForWhichAllCampaignsCanBeCompleted:
              row['allCampaignCompleted'] ?? null,
            VehiclesForWhichSomeCampaignsCanBeCompleted:
              row['someCampaignCompleted'] ?? null,
            AllVehiclesInInventory: row['allVehicles'] ?? null,
          };
        });
        this.calculateDynamicHeight();
        // this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id); // Removes the loading area
      });
    });
  }

  onDataViewClick(params: any) {
    // console.log('View Data Clicked', params);
    this.selectedValue = params.value ?? '';
    // console.log('Selected Value from market:', this.selectedValue);
    const columnName =
      params?.colDef?.field ?? params?.column?.getColId?.() ?? '';
    this.router.navigate(['InventoryCampaignDetails'], {
      queryParams: {
        column: columnName,
        value: this.selectedValue,
        defectCode: params.data?.DefectCode ?? null,
      },
    });
    this.commonService.marketScreenSelectedValue.next(this.selectedValue);
  }

  goToRegionalPage() {
    this.router.navigate(['campaign_inventory_internal_region'], {
      queryParams: {
        column: 'region',
        value: this.commonService.nationalScreenSelectedValue.getValue(),
      },
    });
  }

  goToNationalPage() {
    this.router.navigate(['campaign_inventory_internal_national']);
  }

  windowPrint() {
    const columns = [
      'Market',
      'VehiclesForWhichAllCampaignsCanBeCompleted',
      'VehiclesForWhichSomeCampaignsCanBeCompleted',
      'AllVehiclesInInventory',
    ];
    const columnHeaders = [
      'Center Code-Center',
      'Vehicles for which all Campaign(s) can be completed',
      'Vehicles for which some Campaign(s) can be completed',
      'All vehicles in Inventory',
    ];
    const currentDate = new Date().toLocaleDateString('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    const currentTime = new Date().toLocaleTimeString('en-US', {
      timeZone: 'America/New_York',
    });

    const details: Array<{ label: string; value: any }> = [
      { label: 'Defect Code', value: this.userEnteredDefectCode || '' },
      { label: 'Details as of', value: currentDate + ' at ' + currentTime },
      ...(this.isMarketFilterActive
        ? [
            {
              label: 'Center Code-Center contains:',
              value: this.marketFilterValue || '',
            },
          ]
        : []),
    ];

    const printedOn = this.exportService.formatEstTimestamp();

    this.exportService.exportPdfWithDetails(
      'Inventory_Campaign_Details_Market',
      this.getFilteredRowData(),
      columns,
      columnHeaders,
      details,
      {
        title: 'ROSS - Inventory Campaign',
        subtitle:
          'Inventory Campaign Details (Internal)-Market - ' +
          this.regionScreenSelectedValue,
        printedOn,
        orientation: 'landscape',
        rowHeight: 28,
        cellPadding: 5,
        columnWidths: [80, 110, 110, 70],
        zebraFillColor: [245, 245, 245],
        headerFillColor: [227, 242, 253],
      }
    );
  }

  private getFilteredRowData(): any[] {
    if (!this.gridApi) return this.rowData;

    const filteredRows: any[] = [];

    // ← iterates only visible rows after filter + sort applied
    this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
      if (node.data) {
        filteredRows.push(node.data);
      }
    });

    // console.log('Filtered rows for PDF:', filteredRows.length, 'of', this.rowData.length);
    return filteredRows.length > 0 ? filteredRows : this.rowData;
  }
  columns: ColDef[] = [
    {
      field: 'Market',
      headerName: 'Center Code-Center',
      floatingFilter: true,
      filter: true,
      flex: 1,
      cellRenderer: ViewDataRendererComponent,
      cellRendererParams: {
        onClick: this.onDataViewClick.bind(this),
      },
    },
    {
      field: 'VehiclesForWhichAllCampaignsCanBeCompleted',
      headerName: 'Vehicles For Which All Campaigns Can Be Completed',
      sortable: true,
      flex: 1,
    },
    {
      field: 'VehiclesForWhichSomeCampaignsCanBeCompleted',
      headerName: 'Vehicles For Which Some Campaigns Can Be Completed',
      sortable: true,
      flex: 1,
    },
    {
      field: 'AllVehiclesInInventory',
      headerName: 'All Vehicles In Inventory',
      sortable: true,
      flex: 1,
    },
  ];

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 0,
    resizable: true,
    floatingFilter: true,
    wrapHeaderText: true,
    autoHeight: true,
    filterParams: {
      closeOnApply: true,
      suppressAndOrCondition: true,
      maxNumConditions: 1,
      trimInput: false,
      filterOptions: [
        // ? explicitly list all filter options you want
        'contains',
      ],
      defaultOption: 'contains',
    },
    headerCheckboxSelectionFilteredOnly: true,
  };

  gridOptions: GridOptions = {
    suppressRowClickSelection: true,
    rowSelection: 'multiple',
    animateRows: true,
    enableCellTextSelection: true,
    ensureDomOrder: true,
    floatingFiltersHeight: 30,
    suppressHorizontalScroll: true,
  };

  onGridReady(params: GridReadyEvent) {
    params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // console.log('Grid API:', this.gridApi);
    this.calculateDynamicHeight();
  }

  onGridSizeChanged() {
    if (!this.gridApi) {
      return;
    }

    // Keep columns fitted so no horizontal scrollbar appears when vertical scrollbar shows.
    this.gridApi.sizeColumnsToFit();
  }

  onPaginationChanged() {
    this.calculateDynamicHeight();
    this.onGridSizeChanged();
  }

  onMarketFilterChanged() {
    this.calculateDynamicHeight();
    this.onGridSizeChanged();
    this.trackMarketFilter();
  }

  trackMarketFilter() {
    if (!this.gridApi) return;
    const activeFilters = this.gridApi.getFilterModel();
    this.marketFilterValue = activeFilters['Market']?.filter ?? '';
    this.isMarketFilterActive = !!this.marketFilterValue;
    this.calculateDynamicHeight();
  }

  private calculateDynamicHeight() {
    if (!this.gridApi) return;

    const displayedRowCount = this.gridApi.getDisplayedRowCount();
    const currentPage = this.gridApi.paginationGetCurrentPage();
    const pageSize = this.gridApi.paginationGetPageSize();
    const startIndex = currentPage * pageSize;
    const visibleRowsOnCurrentPage = Math.max(
      Math.min(displayedRowCount - startIndex, pageSize),
      0
    );
    const cappedRowCount = Math.min(
      Math.max(visibleRowsOnCurrentPage, 1),
      this.MAX_VISIBLE_ROWS
    );

    const chromeHeight =
      this.HEADER_HEIGHT +
      this.FLOATING_FILTER_HEIGHT +
      this.PAGINATION_PANEL_HEIGHT;

    this.dynamicTableHeight = chromeHeight + cappedRowCount * this.ROW_HEIGHT;
    if (displayedRowCount === 0) {
      if (this.isMarketFilterActive) {
        this.noRowsTemplate = `
          <div class="icd-no-rows" role="status" aria-live="polite">
            <span>No matching rows found for the applied filter.</span>
            <br/>
            <span style="font-size:12px; color:#888;">Try adjusting or clearing the column filter.</span>
          </div>`;
      } else {
        this.noRowsTemplate = `<div class="icd-no-rows" role="status" aria-live="polite">No Rows Found</div>`;
      }
      this.gridApi.showNoRowsOverlay?.();
    } else {
      this.gridApi.hideOverlay?.();
    }
  }

  onRowClicked(event: any) {
    // console.log('Row clicked: ', event.data);
  }

  firstColumnNavigation() {
    if (this.gridApi) {
      const selectedRows = this.gridApi.getSelectedRows();
      console.log('Selected option :', selectedRows);
      const selectedFirstColumn = selectedRows.map((row) => {
        return row?.[Object.keys(row)[0]];
      });
      // console.log('Confirm Not in Inventory Rows:', selectedFirstColumn);
    }
  }
}
